export const Constants = {
  ACCESS_TOKEN: "AccessToken",
  USER_INFO: "UserInfo",
  ACTIVE_ORGANIZATION: "ActiveOrganization",
  THEME_COLOR: "ThemeColor",
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL!,
  SITE_URL: process.env.REACT_APP_SITE_URL ?? "https://carelyit.com",
  SITE_NAME: "Carely IT",
  SUPPORT_PHONE: "01916707697",
  SUPPORT_EMAIL: "zonayed@carelyit.com",
};


